const flagOverrides: Record<string, string> = {
	en: 'gb',
	cs: 'cz',
}

export const getCountryFlagIconName = (languageCode?: string | null): string => {
	const code = languageCode?.toLowerCase() ?? ''
	return flagOverrides[code] ?? code
}
